// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1ecvu","rootCenter":"LoadMoreObserver_rootCenter__3D7Co","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__eJNxQ"};